/**
 * Блок «нет результатов» подгружается JS, чтобы поисковики не индексировали текст.
 */
export function injectNoFoundBlock() {
    const $mount = document.querySelector('.js-noFoundBlockMount');
    if (!$mount) {
        return;
    }

    const imgSrc = $mount.dataset.img || '';
    const isActive = $mount.dataset.active === '1';

    $mount.outerHTML = `
        <div class="Object-tile__no-found-container js-containerResultFilter${isActive ? ' is-active' : ''}">
            <div class="Object-tile__no-found-label">Подбор для вас</div>
            <div class="Object-tile__no-found-section Object-tile__no-found-section--image">
                <img class="Object-tile__no-found-img" src="${imgSrc}">
            </div>
            <div class="Object-tile__no-found-section">
                <p class="Object-tile__no-found-title">Такой вариант мы пока не нашли</p>
                <p class="Object-tile__no-found-text">Но мы можем найти лично Для Вас. Звонок по России бесплатный!</p>
            </div>
            <div class="Object-tile__no-found-section Object-tile__no-found-section--actions">
                <button type="button" class="Object-tile__no-found-call js-no-found-call">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9645 16.6102L17.7915 15.4372C17.2055 14.8512 16.2555 14.8512 15.6705 15.4372L14.7485 16.3592C14.5425 16.5652 14.2305 16.6342 13.9645 16.5172C12.6285 15.9322 11.3085 15.0452 10.1315 13.8682C8.95954 12.6962 8.07554 11.3822 7.48954 10.0512C7.36754 9.77621 7.43854 9.45321 7.65154 9.24021L8.47754 8.41421C9.14854 7.74321 9.14854 6.79421 8.56254 6.20821L7.38954 5.03521C6.60854 4.25421 5.34254 4.25421 4.56154 5.03521L3.90954 5.68621C3.16854 6.42721 2.85954 7.49621 3.05954 8.55621C3.55354 11.1692 5.07154 14.0302 7.52054 16.4792C9.96954 18.9282 12.8305 20.4462 15.4435 20.9402C16.5035 21.1402 17.5725 20.8312 18.3135 20.0902L18.9645 19.4392C19.7455 18.6582 19.7455 17.3922 18.9645 16.6102V16.6102Z M13 6.99109C14.031 6.97709 15.067 7.35909 15.854 8.14609 M18.682 5.31811C17.113 3.74911 15.056 2.96411 13 2.96411 M17.0085 11C17.0225 9.969 16.6405 8.933 15.8535 8.146 M18.6816 5.31812C20.2506 6.88712 21.0356 8.94412 21.0356 11.0001" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Позвонить
                </button>
                <button type="button" class="Object-tile__no-found-create js-createBooking">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="#316BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Заполнить заявку
                </button>
            </div>
        </div>
    `;
}

injectNoFoundBlock();
